import { render, staticRenderFns } from "./ingress-view.vue?vue&type=template&id=48981b83&"
import script from "./ingress-view.vue?vue&type=script&lang=js&"
export * from "./ingress-view.vue?vue&type=script&lang=js&"
import style0 from "./ingress-view.vue?vue&type=style&index=0&id=48981b83&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports